import { connect } from 'react-redux';
import { createSelector } from 'reselect';

import type { RouteContext } from 'react-resource-router';
import type { State } from 'state';
import { exitTestModeAction } from 'state/actions/login';
import { getBaseUrl } from 'state/selectors/env';
import { getSharedPortalName } from 'state/selectors/help-center';
import { getSignUpState } from 'state/selectors/sign-up';
import { withAnalyticsContext } from '@atlaskit/analytics-next';
import { withPathParams } from '@atlassian/help-center-common-component/with-path-params';

import SignUp from './sign-up';

type ExternalProps = Omit<RouteContext, 'action'>;

const selector = createSelector(
    (state: State) => getSharedPortalName(state),
    (_: State, props: ExternalProps) => props.match.params.portalId,
    (state: State) => getSignUpState(state),
    (state: State) => getBaseUrl(state),
    (sharedPortalName, portalId, signUpState, baseUrl) => ({
        portalId,
        baseUrl,
        title: sharedPortalName,
        authInfo: signUpState.authInfo,
        emailAddress: signUpState.emailAddress,
        requestSummary: signUpState.requestSummary,
    })
);

export default connect(selector, {
    onExitTestMode: exitTestModeAction,
})(withAnalyticsContext({ component: 'signUp' })(withPathParams(SignUp)));
